export const CHART_COLORS = {
  textPrimary: '#0F172A', // slate-900: títulos, valores
  textSecondary: '#475569', // slate-600: títulos de eje
  textMuted: '#64748B', // slate-500: labels
  textDisabled: '#94A3B8', // slate-400: estado sin datos
  borderStrong: '#CBD5E1', // slate-300: leyenda oculta, outline de labels
  border: '#E2E8F0', // slate-200: líneas/ejes
  grid: '#F1F5F9', // slate-100: grilla
  bg: '#F8FAFC', // slate-50: fondo de superficies
  surface: '#FFFFFF', // blanco: tarjetas/toolbars
  overlay: 'rgba(15, 23, 42, 0.05)', // textPrimary @ 5%: hover sutil
};

export const COLOR_PALETTE = [
  '#003D7A', // navy CDTEC
  '#0EA5E9', // sky-500
  '#10B981', // emerald-500
  '#F59E0B', // amber-500
  '#EF4444', // red-500
  '#8B5CF6', // violet-500
  '#EC4899', // pink-500
  '#14B8A6', // teal-500
  '#F97316', // orange-500
  '#6366F1', // indigo-500
];

export default CHART_COLORS;
